export const parseUrlParam = (paramName: string): string => {
    const urlParams = new URLSearchParams(window.location.search);
    const raw = urlParams.get(paramName);
    if (!raw) {
        return '';
    }
    return decodeURIComponent(raw.trim());
};
